<form (ngSubmit)="submit()" class="tw-flex tw-flex-col tw-items-center tw-pt-6">
  <mh-auth-form-header titleKey="auth_login.mfa.title" explainKey="auth_login.mfa.explain"></mh-auth-form-header>

  <div class="tw-mt-[35px]">
    <mh-code-input [formControl]="code" [hasError]="!!errorKey()"></mh-code-input>
  </div>

  @if (expired()) {
    <p class="tw-mb-0 tw-mt-[18px] tw-text-center tw-font-rubik tw-text-sm tw-text-red-500">
      {{ 'auth_login.mfa.code_expired' | translate }}
    </p>
  } @else {
    <p class="tw-mb-0 tw-mt-[18px] tw-text-center tw-font-rubik tw-text-sm tw-text-main-text">
      {{ 'auth_login.mfa.expires_in' | translate }}
      <span class="tw-text-red-500">{{ countdown() }}</span>
    </p>

    @if (errorKey()) {
      <p class="tw-mb-0 tw-mt-[6px] tw-text-center tw-font-rubik tw-text-sm tw-text-red-500">
        {{ errorKey() | translate }}
      </p>
    }
  }

  @if (lowAttempts() !== null) {
    <p class="tw-mb-0 tw-mt-[6px] tw-text-center tw-font-rubik tw-text-sm tw-text-main-text">
      {{ 'auth_login.mfa.attempts_left' | translate: { count: lowAttempts() } }}
    </p>
  }

  @if (rememberDeviceAllowed()) {
    <label class="tw-mt-[20px] tw-flex tw-cursor-pointer tw-items-center tw-font-rubik tw-text-sm tw-text-main-text">
      <input
        type="checkbox"
        class="tw-mr-2 tw-cursor-pointer tw-rounded tw-border-2 tw-border-main-text tw-text-main focus:tw-ring-0 focus:tw-ring-offset-0 disabled:tw-cursor-not-allowed"
        [checked]="rememberDevice()"
        [disabled]="loading()"
        (change)="toggleRememberDevice($event)"
      />
      {{ 'auth_login.mfa.remember_device' | translate }}
    </label>
  }

  <div class="tw-mt-[29px]">
    @if (expired()) {
      <mh-core-lib-button
        [isPrimary]="true"
        [isDisabled]="!canResend()"
        [isDownloading]="loading()"
        [text]="'auth_login.mfa.request_new_code' | translate"
        customClass="!tw-w-auto !tw-min-w-[200px] tw-whitespace-nowrap"
        loaderClass="tw-mx-auto"
        textClass="tw-font-rubik"
        (clicked)="resend()"
      ></mh-core-lib-button>
    } @else {
      <mh-core-lib-button
        [isPrimary]="true"
        [isDisabled]="!canVerify()"
        [isDownloading]="loading()"
        [text]="'auth_login.submit' | translate"
        customClass="!tw-w-auto !tw-min-w-[110px] tw-whitespace-nowrap"
        loaderClass="tw-mx-auto"
        textClass="tw-font-rubik"
      ></mh-core-lib-button>
    }
  </div>

  @if (!expired()) {
    <div class="tw-mt-[18px] tw-text-center tw-font-rubik tw-text-sm">
      @if (outOfResends()) {
        <span class="tw-text-main-text">{{ 'auth_login.mfa.no_resends_left' | translate }}</span>
      } @else if (canResend()) {
        <button
          type="button"
          class="tw-border-0 tw-bg-transparent tw-p-0 tw-text-main-blue tw-underline"
          (click)="resend()"
        >
          {{ 'auth_login.mfa.request_new_code' | translate }}
        </button>
      } @else {
        <span class="tw-text-disabled-font">
          {{ 'auth_login.mfa.resend_available_in' | translate: { seconds: resendIn() } }}
        </span>
      }
    </div>
  }

  @if (lowResends() !== null) {
    <p class="tw-mb-0 tw-mt-[6px] tw-text-center tw-font-rubik tw-text-sm tw-text-main-text">
      {{ 'auth_login.mfa.resends_left' | translate: { count: lowResends() } }}
    </p>
  }

  <button
    type="button"
    class="tw-mt-[26px] tw-border-0 tw-bg-transparent tw-p-0 tw-font-rubik tw-text-sm tw-text-main-text tw-underline disabled:tw-cursor-not-allowed disabled:tw-text-disabled-font"
    [disabled]="loading()"
    (click)="backRequested.emit()"
  >
    <i class="far fa-arrow-left tw-mr-1"></i>{{ 'auth_login.back' | translate }}
  </button>
</form>
